import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {  PrescriptionListApi } from '../api/prescriptionList.api';
import { switchMap, map } from 'rxjs/operators';
import {  PrescriptionList,  PrescriptionListData } from '../../../interfaces/pharmacy/prescriptionList';

@Injectable()
export class PrescriptionListService extends  PrescriptionListData {

  constructor(private api:  PrescriptionListApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable< PrescriptionList>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable< PrescriptionList> {
    return this.api.add(url,data);
  }



  update(url: string, data: PrescriptionList): Observable< PrescriptionList> {
    return this.api.update(url,data);
  }



  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
